






























import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import CreateTopic from './create-topic.vue'
import EditTopic from './edit-topic.vue'
class  PageTopicRequest extends PageRequest{
    title:string;
}

@Component({
    components:{CreateTopic,EditTopic}
})
export default class Topics extends AbpBase{
    edit(){
        this.editModalShow=true;
    }
    //filters
    pagerequest:PageTopicRequest=new PageTopicRequest();

    createModalShow:boolean=false;
    editModalShow:boolean=false;
    get list(){
        return this.$store.state.topic.list;
    };
    get loading(){
        return this.$store.state.topic.loading;
    }
    create(){
        this.createModalShow=true;
    }
    
    pageChange(page:number){
        this.$store.commit('topic/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('topic/setPageSize',pagesize);
        this.getpage();
    }
    search() {
        this.$store.commit("topic/setCurrentPage", 1);
        this.getpage();
    }
    async getpage(){
      
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        //filters

        await this.$store.dispatch({
            type:'topic/getAll',
            data:this.pagerequest
        })
    }
    get pageSize(){
        return this.$store.state.topic.pageSize;
    }
    get totalCount(){
        return this.$store.state.topic.totalCount;
    }
    get currentPage(){
        return this.$store.state.topic.currentPage;
    }
    viewTopic(id) {
        let routeData = this.$router.resolve({
            name: "frontTopicDetail",
            params:{id:id}
        });
        window.open(routeData.href, '_blank');
    }
    columns=[{
        title:this.L('Title'),
        key:'title',
        tooltip: true
    },{
        title:this.L('SystemName'),
        key:'systemName'
    },{
        title:this.L('CreationTime'),
        key:'creationTime',
        width: 120,
        render:(h:any,params:any)=>{
            return h('span',new Date(params.row.creationTime).toLocaleDateString())
        }
    },{
        title:this.L('Actions'),
        key:'Actions',
        width:160,
        align: 'center',
        render:(h:any,params:any)=>{
            let self = this;
            return h('div',[
                h('Button',{
                    props:{
                        type:'primary',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.$store.commit('topic/edit',params.row);
                            this.edit();
                        }
                    }
                },this.L('Edit')),
                h('Button',{
                    props:{
                        type:'primary',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.viewTopic(params.row.id);
                            
                        }
                    }
                },'预览'),
                h('Button',{
                    props:{
                        type:'error',
                        size:'small',
                        disabled: params.row.isStatic
                    },
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title:this.L('Tips'),
                                    content:this.L('topicDeleteWarningMessage'),
                                    okText:this.L('Yes'),
                                    cancelText:this.L('No'),
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'topic/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },this.L('Delete'))
            ])
        }
    }]
    async created(){
        this.getpage();
    }
}
